import { revenueByMonthMock } from "./revenueMock";

type Translate = (
  key: string,
  params?: Record<string, string | number>
) => string;

interface RevenueChartContext {
  t: Translate;
  locale: string;
  isDark: boolean;
}

const BRAND = "#2463EB";
const AXIS_LABEL = "#A3AED0";

export const buildRevenueMonthlyChartData = ({
  t,
}: Pick<RevenueChartContext, "t">) => [
  {
    name: t("revenue.totalRevenue"),
    data: revenueByMonthMock.map((m) => m.value),
    color: BRAND,
  },
];

export const buildRevenueMonthlyChartOptions = ({
  t,
  locale,
  isDark,
}: RevenueChartContext) => ({
  chart: {
    toolbar: { show: false },
    fontFamily: "inherit",
  },
  tooltip: {
    theme: isDark ? "dark" : "light",
    style: { fontSize: "12px" },
    y: {
      formatter: (val: number) =>
        new Intl.NumberFormat(locale, {
          style: "currency",
          currency: "VND",
          maximumFractionDigits: 0,
        }).format(val),
    },
  },
  xaxis: {
    categories: revenueByMonthMock.map((m) =>
      new Date(2000, m.month - 1, 1).toLocaleDateString(locale, {
        month: "short",
      })
    ),
    labels: {
      style: { colors: AXIS_LABEL, fontSize: "12px", fontWeight: 500 },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },
  yaxis: {
    labels: {
      style: { colors: AXIS_LABEL, fontSize: "12px" },
      formatter: (val: number) =>
        t("revenue.millionsShort", { value: (val / 1000000).toFixed(0) }),
    },
  },
  grid: {
    borderColor: "rgba(163, 174, 208, 0.3)",
    strokeDashArray: 5,
    xaxis: { lines: { show: false } },
  },
  dataLabels: { enabled: false },
  plotOptions: {
    bar: { borderRadius: 8, columnWidth: "32px" },
  },
  fill: {
    type: "gradient",
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      colorStops: [
        { offset: 0, color: BRAND, opacity: 1 },
        { offset: 100, color: "rgba(36, 99, 235, 0.28)", opacity: 0.6 },
      ],
    },
  },
});
